<template>
  <div
      @click.stop
      class="popup-thank-you"
      v-body-scroll-lock="modalIsOpen"
      v-if="modalIsOpen"
  >
    <div class="popup_thank_inner">
         <div>
           <Select />
         </div>
    </div>
  </div>
</template>

<script>
import {bus} from "../../../utils/bus";
import Select from '../select/Select'
import {mapState} from "vuex";
export default {
  name: "PopupCountry",
  components:{
    Select
  },
  data() {
    return {
      modalIsOpen: false,
    }
  },
  methods: {
    closeModal() {
      this.modalIsOpen = false;
      if(document.querySelector('.overlay-body').classList.contains('active-modal')) {
        document.querySelector('.overlay-body').classList.remove('active-modal')
      }
    },
    openModal() {
      this.modalIsOpen = true;
      document.querySelector('.overlay-body').classList.add('active-modal')
    }
  },
  mounted() {
    bus.$on('country-close-modal', () => {
      this.closeModal()
    });
    bus.$on('country-open-modal', () => {
      this.openModal()
    })
  },
  watch: {
    selectedCountry: function (newCountry) {
      if (window.location.search.includes('?success')) {
        const queryString = window.location.search;
        const urlParams = new URLSearchParams(queryString);
        const social = urlParams.get('social')
        const body = {
          country: newCountry,
          email: this.email,
          social: social
        }
        this.$store.dispatch('updateCountryEmail', body).then(() => {
          this.$gtm.trackEvent({
            event: 'lgcompromo',
            category: 'promo_map',
            eventCategory: 'promo_map',
            action: social,
            eventAction: social,
            label: this.selectedCountry,
            eventLabel: this.selectedCountry,
            noninteraction: false // Optional
          });
          this.closeModal()
          bus.$emit('thank-open-modal' +
              '' +
              '', true)
        })
      }
    }
  },
  computed:{
    ...mapState({
      selectedCountry: "selectedCountry",
      email: "email"
    })
  }
}
</script>

<style lang="scss">
@import "popup-country";
</style>